export const affixThemeToken: any = {};
